// extracted by mini-css-extract-plugin
export default {"button":"buttonComponent_button__ct4Ae"};